import cpcIcon from '../../assets/cl_icon.svg';

export function CpcIcon({ size = 18, title, filter }: { size?: number; title?: string; filter?: string }) {
  return (
    <img
      src={cpcIcon}
      alt="Conversation Lead"
      title={title}
      style={{
        width: size,
        height: size,
        filter: filter,
      }}
    />
  );
}
